/* eslint-disable react/prop-types */
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";
import React from "react";
import Modal from "../../../components/common/Modal/Modal";
import BSGLogo from "../../../assets/images/logo.png";
// import Typography from "../../../components/common/new/Typography/Typography";

// const Styles = {
//   alignComponent: {
//     display: "flex",
//     justifyContent: "center",
//     flexWrap: "wrap",
//   },
//   alignMessage: {
//     width: 450,
//     display: "flex",
//     textAlign: "center",
//     flexWrap: "wrap",
//   },
// };

function TermsAndService({ open, onClose }) {
  return (
    <div>
      <Modal open={open} customStyle={{ height: "90%", width: "70%" }}>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingBottom: "14px",
          }}
        >
          <Typography
            style={{
              textAlign: "center",
              flex: "1",
              fontWeight: 500,
              fontSize: "18px",
            }}
          >
            TERMS OF SERVICE
          </Typography>
          <Box>
            <CloseIcon
              sx={{
                color: "#A4A4A4",
                cursor: "pointer",
                stroke: "#A4A4A4",
                strokeWidth: 1,
              }}
              onClick={onClose}
            />
          </Box>
        </Box>

        <Typography
          style={{
            height: "calc(100% - 48px)",
            overflowY: "auto",
            padding: "16px",
            lineHeight: "1.6",
            boxShadow: "inset 0px 0px 8px 0px rgba(0, 0, 0, 0.07)",
          }}
        >
          By accessing the BSG Database System (“the BDS Website”), the BSG
          Statistics In-charges (SIs) agree to the following terms and
          conditions concerning the use of this website (“Terms of Service”),
          along with more specific restrictions that may apply to specific
          part(s) of this website.
          <ol>
            <li>
              PURPOSE: The BDS Website is maintained by the Bharat Soka Gakkai
              (“BSG”) for the purpose of maintaining organizational statistics.
              The BDS Website is exclusively available only to the SIs at
              various levels in the organization structure of BSG.
            </li>
            <li>
              PERMISSIONS: BSG grants permission to the SIs to visit and use the
              BDS Website for performing various functions relating to
              maintenance of organizational statistics, in the following manner:
              <ol type="a">
                <li>
                  To mark attendance of all attendees in different internal BSG
                  meetings, at such organizational level as may be specified.
                </li>
                <li>
                  To access and download various reports/other resources for
                  maintaining organizational statistics.
                </li>
                <li>
                  To access notifications & other features pertaining to BSG as
                  specified by BSG from time to time.
                </li>
                <li>
                  To perform such other functions as required from the SIs and
                  which are duly specified by BSG from time to time.
                </li>
              </ol>
            </li>
            <li>
              REGISTRATION:
              <ol type="a">
                <li>
                  In order to access the BDS Website, SIs must create an account
                  based on their Membership ID. They are responsible for
                  maintaining the confidentiality of their account credentials
                  and for any activities conducted through their account.
                </li>
                <li>
                  BSG will not be responsible for any loss, inconvenience or
                  mental agony resulting from misuse of Membership ID / Password
                  / account details with respect to the BDS Website.
                </li>
              </ol>
            </li>
            <li>
              DATA USAGE:
              <ol type="a">
                <li>
                  The BDS Website contains all information including personal
                  information of BSG members (such as name, profile photograph,
                  address, email address, phone number, UIN, names of family
                  members, etc.). Such information specific to an organizational
                  unit is made accessible to the designated SIs as assigned by
                  BSG from time to time. The BDS Website also collects
                  non-personal information, such as device information, IP
                  address, and usage statistics, for analytical and security
                  purposes. BSG maintains access to the entire database in full.
                </li>
                <li>
                  Such information will be used for statistical purposes only.
                  BSG does not rent, sell or share the information contained in
                  the BDS Website, and shall not disclose any such personal
                  information to third parties, except as specified in these
                  Terms of Service. SIs shall adhere to this requirement.
                  Notwithstanding anything contained above, BSG reserves the
                  right to disclose personal information where it believes in
                  good faith that such disclosure is required by law.
                </li>
                <li>
                  By accessing the BDS Website, SIs acknowledge and grant to the
                  use of the information contained in this website in the manner
                  prescribed in these Terms of Service.
                </li>
                <li>
                  By using the BDS Website, SIs acknowledge and grant BSG with
                  the right to monitor and track their activities within the
                  website to detect and prevent fraudulent activities.
                </li>
              </ol>
            </li>
            <li>
              DATA ACCESS CONTROL: Access to data contained in the BDS Website
              shall be restricted to authorized personnel only, using
              appropriate access control mechanisms.
            </li>
            <li>
              DATA STORAGE: All data shall be stored securely in a controlled
              environment (“Amazon Web Services India Ltd. (AWS)”) with
              appropriate physical and logical security measures, including
              firewalls, data encryption, intrusion detection systems, and
              access logs etc.
            </li>
            <li>
              COMPLIANCE WITH LAWS: The BDS Website shall comply with applicable
              data protection and privacy laws & regulations to data contained
              therein.
            </li>
            <li>
              DATA BREACH NOTIFICATION: In the event of a data breach that
              compromises member data, BSG shall promptly notify the affected
              members and provide information on the nature of the breach,
              potential risks, and recommended actions to mitigate harm. SIs
              shall assist BSG in this exercise.
            </li>
            <li>
              WITHDRAWAL OF CONSENT: SIs shall have the right to withdraw their
              consent from performing their responsibilities on the BDS Website.
              Such withdrawal shall limit or prevent the SIs access to the
              features of the BDS Website.
            </li>
            <li>
              SI RESPONSIBILITIES: SIs are responsible for their usage of the
              BDS Website and must not engage in any unlawful, fraudulent,
              harmful activities, or activities which infringe the privacy of
              any member.
            </li>
            <li>
              AVAILABILITY OF ACCESS: While BSG strives to ensure uninterrupted
              access to the BDS Website, however it does not guarantee
              continuous availability and reserves the right to suspend or
              terminate access to the services temporarily or permanently
              without prior notice.
            </li>
            <li>
              INTELLECTUAL PROPERTY: The BDS Website and its contents, including
              but not limited to text, photographs, graphics, logos, and
              software, are protected by intellectual property laws and are
              owned or licensed for use by BSG. SIs agree not to reproduce,
              modify, distribute, or create derivative works based on such
              content without explicit permission. The trademark BSG{" "}
              <img src={BSGLogo} alt="BSG Logo" /> is also held by BSG.
            </li>
            <li>
              PROHIBITED CONDUCT: SIs agree not to engage in any conduct that
              may disrupt the operations of the BDS Website, infringe upon the
              rights of others, or violate any applicable laws or regulations.
              This includes but is not limited to unauthorized access, spamming,
              transmitting malware, or engaging in any form of harassment or
              abusive behaviour (such as adding inappropriate and offensive
              content as information).
            </li>
            <li>
              TERMINATION: BSG reserves the right to suspend or terminate SI
              accounts and access to services for violations of the terms of use
              or for any other reason deemed necessary.
            </li>
            <li>
              LIMITATION OF LIABILITY: BSG shall not be held liable for any
              direct, indirect, incidental, consequential, or punitive damages
              arising out of the use or inability to use the BDS Website,
              including but not limited to loss of data, loss of profits, or
              damages resulting from third-party actions.
            </li>
            <li>
              {" "}
              INDEMNITY: As a condition of use of the BDS Website, the SI shall
              indemnify BSG, its affiliates, directors, employees, from and
              against any and all actions, claims, losses, damages, liabilities
              and expenses (including reasonable attorneys’ fees) arising out of
              use hereof, including without limitation, any infringement of the
              copyright or trademarks that are owned by BSG, or any claims
              alleging facts that if true would constitute a breach of these
              Terms of Service.{" "}
            </li>
            <li>
              {" "}
              PRIVACY: The BDS Website’s privacy policy outlines how data is
              collected, used, and protected. SIs are encouraged to review the
              privacy policy to understand the practices regarding data privacy
              and security.{" "}
            </li>
            <li>
              {" "}
              MODIFICATIONS: BSG reserves the right to modify or update these
              Terms of Service at any time. SIs will be notified of significant
              changes, and continued use of the services after such changes
              constitute acceptance of the modified terms.{" "}
            </li>
            <li>
              {" "}
              GOVERNING LAW, JURISDICTION & DISPUTE RESOLUTION: These Terms of
              Service are governed by the laws of the Republic of India. SIs
              hereby consent and submit to the exclusive jurisdiction and venue
              of Courts in New Delhi, India in all disputes arising out of or
              relating to the use of the BDS Website.{" "}
            </li>
            <li>
              {" "}
              GENERAL: Nothing contained in these Terms of Service is in
              derogation of BSG’s right to comply with Governmental, Court and
              Law enforcement requests or requirements relating to use of the
              BDS Website or information provided to or gathered by BSG with
              respect to such use. These Terms of Service constitutes the entire
              agreement between the SI and BSG with respect to the BDS Website.{" "}
            </li>
            <li>
              {" "}
              SEVERABILITY: Except as specified in Section 19 (Governing Law,
              Jurisdiction and Dispute Resolution), if any provision of this
              Agreement shall be unlawful, void, or for any reason
              unenforceable, then that provision shall be deemed severable for
              these Terms of Service and shall not affect the validity and
              enforceability of any remaining provisions.{" "}
            </li>
          </ol>
        </Typography>
      </Modal>
    </div>
  );
}
export default TermsAndService;
